export const mobile_validation=(value)=>{
  if (value.length !==10) {
      return false;
  }
  if (value.length !==10) {
      return false;
  }
var regex=/^[6-9]\d{9}$/
if(!regex.test(value)){
return false
}

  return true;
}

export const password_validation=(value)=>{
  if (value.length <6 || value.length>15) {
      return false;
  }
  return true;
}

export const otp_validation=(value)=>{
  if (value.length!=4) {
      return false;
  }
  return true;
}
